// Helpers for the "Employees" / "Employee To" numeric fields in Bots Management.
// Rules: digits only, no leading zero, must be a positive integer (>= 1).

// Sanitizes raw input as the user types: keeps digits only and strips leading
// zeros, so the field can never hold "0", "007" or a non-numeric value.
export function sanitizeEmployeesInput(raw: string): string {
  return (raw || "").replace(/\D/g, "").replace(/^0+/, "");
}

// Parses a sanitized employees value. Returns a positive integer, or null when
// the field is empty / not a positive integer.
export function parseEmployeesNumber(raw: string): number | null {
  const cleaned = sanitizeEmployeesInput(raw);
  if (!cleaned) return null;
  const n = Number(cleaned);
  return Number.isInteger(n) && n > 0 ? n : null;
}
